import { useLocation } from 'react-router-dom'

export const useLastPathSegment = () => {
  const { pathname } = useLocation()
  const segments = pathname.split('/').filter((segment) => segment !== '')

  return segments[segments.length - 1]
}
